import React, { useState, useEffect, useReducer, useRef } from 'react';
import ReactDOM from 'react-dom';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import cx from 'classnames';

import { Flex } from 'antd-mobile';

import './index.less';
const ctx = document.querySelector('#showPopup');
const ConfirmModal = ({
  leftTxt,
  rightTxt,
  title = '温馨提示',
  titleView,
  content,
  contentView,
  onCancelPress,
  onConfirmPress,
  leftView,
  rightView,
  hideRightText,
  hideLeftText,
  btnClassName,
  btnContainerStyle = {},
  popupStyle = {},
  contentClass,
  contentStyle = {},
  leftStyle,
  rightStyle,
  leftClassName = '',
  rightClassName = '',
  isClickNull = false,
  version = '',
  showCloseIcon = false,
  maskStyle = {},
  customContent = null,
  onClose = null
}) => {
  const ContentView = () => {
    const cancelFun = () => {
      ReactDOM.render('', ctx);
    };
    return (
      <Flex
        className={`conform-popup-am-modal-mask${version ? `-${version}` : ''}`}
        align="center"
        justify="center"
        style={{
          ...maskStyle,
          ...(showCloseIcon ? { flexDirection: 'column' } : {})
        }}
        onClick={() => {
          isClickNull && cancelFun();
        }}>
        {customContent ? (
          customContent({ cancelFun })
        ) : (
          <Flex
            direction="column"
            justify="center"
            className="confirm-modal-popup-view"
            style={popupStyle}
            onClick={(e) => e.stopPropagation()}>
            {titleView ? titleView : <Flex className="conform-title">{title}</Flex>}
            {contentView ? (
              typeof contentView === 'function' ? (
                contentView()
              ) : (
                contentView
              )
            ) : (
              <Flex className={cx('content-view', contentClass)} style={{ ...contentStyle }}>
                {content}
              </Flex>
            )}
            <Flex
              align="center"
              justify="between"
              className={cx('btn-container', btnClassName)}
              style={btnContainerStyle}>
              {leftView ? (
                typeof leftView === 'function' ? (
                  leftView({ cancelFun })
                ) : (
                  leftView
                )
              ) : hideLeftText ? null : (
                <CommonBtn
                  // title={leftTxt || '取消'}
                  className={`left-btn btn ${leftClassName}`}
                  style={{ ...leftStyle }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onCancelPress && onCancelPress();
                    cancelFun();
                  }}>
                  {leftTxt || '取消'}
                  {!!version && <i className="iconfont icon-arrow-right" />}
                </CommonBtn>
              )}
              {rightView ? (
                typeof rightView === 'function' ? (
                  rightView({ cancelFun })
                ) : (
                  rightView
                )
              ) : hideRightText ? null : (
                <CommonBtn
                  // title={rightTxt || '确定'}
                  className={`right-btn btn ${rightClassName}`}
                  style={{ ...rightStyle }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onConfirmPress && onConfirmPress(cancelFun);
                    cancelFun();
                  }}>
                  {rightTxt || '确定'}
                  {!!version && <i className="iconfont icon-arrow-right" />}
                </CommonBtn>
              )}
            </Flex>
          </Flex>
        )}
        {showCloseIcon && (
          <i
            className="iconfont icon-close"
            onClick={(e) => {
              e.stopPropagation();
              if (onClose) {
                onClose(cancelFun);
              } else {
                onCancelPress && onCancelPress(cancelFun);
              }
              cancelFun();
            }}
          />
        )}
      </Flex>
    );
  };

  ReactDOM.render(<ContentView />, ctx);
};
module.exports = ConfirmModal;



// WEBPACK FOOTER //
// ./src/widget/ConfirmModal/index.js